import { StyledTitle } from '@/shared/styles';
import styled from 'styled-components';

export const StyledFeatureGroupTitle = styled(StyledTitle)`
  text-align: ${(props) => (props.$isRtl ? 'left' : 'right')} !important;
  width: 100%;
  margin: 0 0 24px 0 !important;
  font-size: 18px !important;
`;
